import { useEffect } from 'react';

import type { DecisionMakerResponsesItem } from '#src/app/pages/decisionMaker/profile/pageContext';
import {
	useDMProfilePagePaginatedResponsesData,
	useDecisionMakerProfilePageData,
} from '#src/app/pages/decisionMaker/profile/pageContext';
import { useQueryParamValue } from '#src/app/shared/hooks/location';
import { useTrackOnce } from '#src/app/shared/hooks/tracking';

type Result = ModelHookResult<
	{
		displayName: string;
		responses: readonly DecisionMakerResponsesItem[];
		hasNextPage: boolean;
		nextPageLoading: boolean;
		showDmrlSeparator: boolean;
	},
	{
		loadMore: () => void;
	}
>;

export function useResponseList(): Result {
	const {
		data: {
			displayName,
			enrichedData,
			featureConfigs: { dmReputationLayer },
		},
	} = useDecisionMakerProfilePageData();

	const showDmrl = useQueryParamValue('showDmrl');
	const isDmrlEnabled = dmReputationLayer.enabled || showDmrl === 'true';
	const showDmrlSeparator = isDmrlEnabled && enrichedData !== null;
	const {
		data: { items, hasNextPage, nextPageLoading },
		actions: { loadMore },
	} = useDMProfilePagePaginatedResponsesData();

	const trackOnce = useTrackOnce();
	useEffect(() => {
		if (items.length > 0) void trackOnce('dm_profile_response_list_view');
	}, [items.length, trackOnce]);

	return {
		data: {
			displayName,
			responses: items,
			hasNextPage,
			nextPageLoading,
			showDmrlSeparator,
		},
		actions: {
			loadMore,
		},
	};
}
